export var SEARCH_DEBOUNCE_MS = 200;